import React from 'react';
import BuildInfo from './src/components/buildDate';

// register link resolver
const { registerLinkResolver } = require("gatsby-source-prismic-graphql")
const linkResolver = require("./src/utils/linkResolver")

registerLinkResolver(linkResolver)


export const wrapPageElement = ({ element, props }) => {
    return <>{element}<BuildInfo /></>;
}